<div class="page-layout carded left-sidenav toolbar-fixed-layout">
    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
        <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
            <label class="component-label"> Actions</label>
            <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
                <div class="button-container flex flex-row justify-start items-center">
                    <button mat-button class="orbitax-flat-button" (click)="reset()"
                            particleAnalytics
                            analyticsCategory="entity-transactions-content"
                            analyticsAction="add-section"
                    >Hallmark Tagging (based on MNE Footprint)
                    </button>
                </div>
                <div class="toolbar-separator"></div>
                <div class="button-container flex flex-row justify-start items-center">
                    <button mat-button class="orbitax-flat-button" (click)="hallmarkTagging()"
                            particleAnalytics
                            analyticsCategory="entity-transactions-content"
                            analyticsAction="add-section"
                    >Hallmark Tagging (based on Keywords)
                    </button>
                </div>
            </div>
        </div>
    </div>

    <mat-sidenav-container>
        <!-- CENTER -->
        <div class="center">
            <!-- CONTENT CARD -->
            <div particleHelpNotes [dynamicNote]="helpNote" class="content-card mat-white-bg">
                <!-- CONTENT TOOLBAR -->
                <div class="content flex flex-col">
                    <div class="main-container flex flex-row flex-wrap justify-start items-start full-grow-no-shrink-no-basis">
                        <mat-tab-group class="full-grow-no-shrink-no-basis"
                                       *ngIf="(reportingLogicConfig$ | async)?.length>0"
                                       (selectedIndexChange)="onTabIndexChange($event)"
                                       [selectedIndex]="selectedFieldSectionIndex">
                            <mat-tab *ngFor="let tab of (reportingLogicConfig$ | async); let i = index"
                                     label="{{tab.header}}">
                                <div *ngIf="selectedFieldSectionIndex == i"
                                     class="m-lr-30 flex flex-row full-grow-no-shrink-no-basis">
                                    <particle-reporting-logic-collapsible (helpNote)="setHelpNote($event)"
                                                                          [config]="tab"
                                                                          [childIndex]="childIndex"
                                                                          (childIndexChanged)="setChildIndex($event)"></particle-reporting-logic-collapsible>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </div>


            </div>
            <!-- / CONTENT CARD -->
        </div>
        <!-- / CENTER -->
    </mat-sidenav-container>

</div>
